export default __webpack_public_path__ + "static/media/img-gt-mode-off-bg@3x.2a5a41d1.jpg";